import { buildTenantAppBaseUrl } from './environmentRouting';

export type SupportTenantOption = {
  id: string;
  name: string;
  slug: string;
  status?: string;
};

export function buildTenantBaseUrl(slug: string): string {
  return buildTenantAppBaseUrl(slug);
}